import { useMemo } from 'react';
import styled from 'styled-components';

import { AnalyticalExaminationType } from '@dreryk/drerykweb-medical-dictionaries-api';

import { EmptyStatePlaceholder, FormLabel, resolveInputLayoutStyles, Table } from '@dreryk/react-components';

import { analyticalExaminationTranslationKeys } from '../../../translations';

import { useAnalyticalExaminationTableConfiguration } from './AnalyticalExaminationSelectorTable.hooks';

type AnalyticalExaminationTableProps = {
   readonly data: AnalyticalExaminationType[];
   readonly removeItem: (item: AnalyticalExaminationType) => void;
};
export const ANALYTICAL_EXAMINATION_TYPES = 'analyticalExaminationTypes';

const StyledAnalyticalExaminationTable = styled.div`
   ${resolveInputLayoutStyles};
`;
StyledAnalyticalExaminationTable.displayName = 'StyledAnalyticalExaminationTable';

const AnalyticalExaminationTable = (props: AnalyticalExaminationTableProps): JSX.Element | null => {
   const tableConfiguration = useAnalyticalExaminationTableConfiguration(props.removeItem);
   const { data } = props;
   const dataConfiguration = useMemo(() => {
      return { data: data };
   }, [data]);

   return (
      <StyledAnalyticalExaminationTable>
         {!data.length && (
            <FormLabel label={analyticalExaminationTranslationKeys.chosenExaminations} testId={'chosenExaminations'} />
         )}
         <Table
            compact
            keyExtractor={'id'}
            columns={tableConfiguration}
            dataConfiguration={dataConfiguration}
            placeholder={
               <EmptyStatePlaceholder
                  heading={analyticalExaminationTranslationKeys.noExaminationsSelected}
                  subheading={analyticalExaminationTranslationKeys.noExaminationsSelectedAdditionalText}
                  fullLength
                  testId={'noExaminationsSelected'}
               />
            }
            testId={'analyticalExaminationResults'}
         />
      </StyledAnalyticalExaminationTable>
   );
};

export { AnalyticalExaminationTable };
